<template>
	<view>
		<view id="nsh-points" @click.stop="show = true" v-if="isInNsh">
			<view>
				<image id='warn-tips' src='/static/images/tip.jpg'></image>
			</view>
			<view><text class="tips">支付时可用银行积分抵扣</text></view>
		</view>
		<nsh-mask v-model="show" >
			<template #default>
				<view class="tips">
					<p>1.可用积分大于等于{{ points.min_price * points.rate }}可参与抵扣</p>
					<p>2.订单大于等于10元可在支付页面选择全额抵扣</p>
					<p>3.按比例抵扣使用积分数量为{{ points.change_times * points.rate }}积分的整数倍，每{{ points.change_times * points.rate
					}}积分抵扣{{ points.change_times }}元
					</p>
					<p>4.积分可多商品叠加使用，以订单结算金额计算是否符合使用规则</p>
					<p>5.积分使用规则与兑换比例或不定期有调整</p>
					<p>6.具体使用规则以深圳农商银行支付页面为准</p>
				</view>
			</template>
			<template #footer>
				知道了
			</template>
		</nsh-mask>
	</view>
</template>

<script>
import NshMask from "@/components/nsh_mask/nsh_mask.vue";
import { isInNsh } from "@/config/nsh.js";
export default {
	name: "nsh_points_tips",
	components: {
		NshMask
	},
	data() {
		return {
			show: false,
			points: {
				min_price: 10,
				max_price: 0,
				change_times: 10,
				rate: 1000
			},
			isInNsh: isInNsh()
		};
	}
};
</script>

<style lang="scss" scoped scoped>
#nsh-points {
	display: flex;
	align-items: center;
	padding: 0;

	.tips {
		font-size: 20rpx;
		color: #A48986;
	}

	#warn-tips {
		display: block;
		width: 24rpx;
		height: 24rpx;
		margin-right: 10rpx;
	}
}
.tips p {
		margin: 10rpx;
		color: #221715;
		font-weight: 500;
		font-size: 28rpx;
	}
</style>